export const getStringFormattedSearchParams = (
  params: Record<string, string | number | Date>,
  isRemoveQuotes: boolean = false
) => {
  const searchParams = new URLSearchParams();

  const formattedRouteSearchParams = Object.entries(params);

  for (const [key, value] of formattedRouteSearchParams) {
    if (value instanceof Date) {
      searchParams.set(key, value.toISOString());
    } else {
      searchParams.set(key, JSON.stringify(value));
    }
  }

  const stringFormattedSearchParams = searchParams.toString();

  if (!stringFormattedSearchParams.length) {
    return '';
  }

  return (
    '?' +
    (isRemoveQuotes ? stringFormattedSearchParams.replace(/%22/g, '') : stringFormattedSearchParams)
  );
};

/**
 * Получить значение из параметров поиска по ключу или пустую строку
 * если параметра не существует
 * @param key
 */
export const getValueFromSearchParamsByKey = (key: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(key) ?? '';
};

/**
 * Выполняет сброс параметров поиска по переднным ключам
 * @param paramsKeys
 */
export const deleteSearchParams = (paramsKeys: string[]) => {
  const searchParams = new URLSearchParams(window.location.search);

  for (const key of paramsKeys) {
    searchParams.delete(key);
  }

  const isSearchParamsEmpty = !searchParams.size;
  let searchParamsString = window.location.pathname;

  if (!isSearchParamsEmpty) {
    searchParamsString = '?' + searchParams.toString();
  }

  history.pushState(null, '', searchParamsString);
};
